<template>
    <div class="container">
        <div class="header">
            <img class="header-icon" v-bind:src="headerIconUrl" />
            <div class="title">{{ title }}</div>
            <div class="summary" v-if="this.summary">{{ summary }}</div>
        </div>
        <div id="detail">
            <VerticalScrollLayout v-bind:rows="rows" />
        </div>
    </div>
</template>

<script>
import DetailSpec from '@/map/detail/DetailSpec'
import VerticalScrollLayout from '@/views/ui/verticalScrollLayout/VerticalScrollLayout'
import VSLSectionRow from '@/views/ui/verticalScrollLayout/VSLSectionRow.js'
import VSLLabelRow from '@/views/ui/verticalScrollLayout/VSLLabelRow.js'
import VSLImageGalleryRow from '@/views/ui/verticalScrollLayout/VSLImageGalleryRow.js'
import MapService from '@/service/MapService'
import LangUtils from '@/utils/LangUtils'

export default {
    name: "MapElementDetailPanel",

    components: {
        VerticalScrollLayout
    },

    props: {
        detailSpec: DetailSpec
    },

    data() {
        return {
            mapService: new MapService(),
            rows: null
        }
    },

    computed: {
        headerIconUrl() {
            return this.mapService.buildUrlToAsset(this.detailSpec.mapBundleId, this.detailSpec.getHeaderIconUrl());
        },

        title() {
            if (this.detailSpec) {
                return this.detailSpec.getName();
            } else {
                return "";
            }
        },

        summary() {
            if (this.detailSpec) {
                return this.detailSpec.getSummary();
            } else {
                return null;
            }
        }
    },

    methods: {
        prepareVSLRows() {
            this.rows = [];

            const infos = this.detailSpec.getInfos(this.$i18n, this.mapService, this.detailSpec.mapBundleId);
            if (infos && infos.length > 0) {
                var informatinSectionAdded = false;
                for (const info of infos) {
                    if (info.type == "images") {
                        this.rows.push(new VSLImageGalleryRow(info.id, info.value));
                    } else {
                        if (!informatinSectionAdded) {
                            this.rows.push(new VSLSectionRow("information_section", this.$i18n.t("map_detail.detail_panel.information_section")));
                            informatinSectionAdded = true;
                        }
                        this.rows.push(new VSLLabelRow(info.id, LangUtils.valueForLanguage(info.label, this.$i18n.locale), info.value, info.type));
                    }
                }
            }

            const description = this.detailSpec.getDescription();
            if (description) {
                this.rows.push(new VSLSectionRow("description_section", this.$i18n.t("map_detail.detail_panel.description_section")));
                this.rows.push(new VSLLabelRow("description", null, description));
            }

            if (this.rows.length == 0) {
                this.rows.push(new VSLSectionRow("information_section", this.$i18n.t("map_detail.detail_panel.information_section")));
                this.rows.push(new VSLLabelRow("no_information_label", null, LangUtils.valueForLanguage(this.$i18n.t("map_detail.detail_panel.no_information_label"))));
            }
        },

        getCoordinatesLatitude(detailSpec) {
            if (detailSpec) {
                return detailSpec.getCoordinatesLatitude();
            } else {
                return "";
            }
        },

        getCoordinatesLongitude(detailSpec) {
            if (detailSpec) {
                return detailSpec.getCoordinatesLongitude();
            } else {
                return "";
            }
        }
    },

    watch: {
        detailSpec: function() {
            this.prepareVSLRows();
        }
    },

    mounted() {
        this.prepareVSLRows();
    }
}
</script>

<style scoped>
.container {
    overflow: scroll;
    padding: 0px;
}

.header {
    display: grid;
    grid-template-columns: 50px auto;
    grid-template-rows: auto auto;
    grid-template-areas: "header-icon title" "header-icon summary";
    padding: 8px;
    padding-top: 16px;
}

.header-icon {
    grid-area: header-icon;
    width: 40px;
}

.title {
    grid-area: title;
    font-weight: bold;
    font-size: 20px;
    text-align: left;
}

.summary {
    grid-area: summary;
    color: #999999;
    font-size: 12px;
    text-align: left;
}
</style>